<template>
  <div>
    <base-header class="pb-4">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Incidencias</h6>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <vue-json-to-csv
            :json-data="itemsToExport"
            :csv-title="'incidencias-' + new Date().valueOf()"
            :labels="labels"
            style="visibility: hidden"
          >
            <!--   <button>
              <b>My custom button</b>
            </button> -->
            <base-button size="sm" type="neutral" ref="myBtn"
              >Exportar</base-button
            >
          </vue-json-to-csv>
          <base-button
            size="sm"
            type="neutral"
            @click="exportData()"
            :loading="loading"
            >Exportar</base-button
          >
        </div>
      </div>
      <!-- Card stats -->
      <div class="row pt-1">
        <div class="col-xl-4 col-md-6">
          <stats-card
            title="Prioridad alta"
            type="gradient-red"
            :sub-title="totalAlta ? totalAlta.toString() : '0'"
            icon="ni ni-active-40"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalAlta ? (totalAlta * 100) / totalIncidencias : "0"
                }}%</span
              >
              <span class="text-nowrap">de las incidencias</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-4 col-md-6">
          <stats-card
            title="Prioridad media"
            type="gradient-orange"
            :sub-title="totalMedia ? totalMedia.toString() : '0'"
            icon="ni ni-chart-pie-35"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalMedia ? (totalMedia * 100) / totalIncidencias : "0"
                }}%</span
              >
              <span class="text-nowrap">de las incidencias</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-4 col-md-6">
          <stats-card
            title="Prioridad baja"
            type="gradient-green"
            :sub-title="totalBaja ? totalBaja.toString() : '0'"
            icon="ni ni-money-coins"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalBaja ? (totalBaja * 100) / totalIncidencias : "0"
                }}%</span
              >
              <span class="text-nowrap">de las incidencias</span>
            </template>
          </stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--4">
      <div class="row">
        <div class="col">
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <div class="p-2">
              <div
                class="row col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div class="col-md-3">
                  <div>
                    <form>
                      <base-input
                        v-model="query"
                        type="search"
                        placeholder="Buscar por equipo, usuario..."
                        clearable
                      />
                    </form>
                  </div>
                </div>
                <div class="col-md-9">
                  <div
                    class="d-flex justify-content-right justify-content-sm-end"
                  >
                    <div class="pr-4">
                      <el-select
                        class="select-primary pagination-select"
                        v-model="prioridad"
                        placeholder="Prioridad"
                        style="width: 100%; height: 46px !important"
                      >
                        <el-option
                          class="select-primary"
                          v-for="item in prioridades"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div>
                      <div class="row">
                        <div class="col pr-1">
                          <base-input label="">
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="configInput"
                              class="form-control datepicker"
                              v-model="fdesde"
                              placeholder="Fecha desde..."
                            >
                            </flat-picker>
                          </base-input>
                        </div>
                        <div class="col pl-0">
                          <base-input label="">
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="configInput"
                              class="form-control datepicker"
                              v-model="fhasta"
                              placeholder="Fecha hasta..."
                            >
                            </flat-picker>
                          </base-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <el-table
                  class="table-responsive align-items-center table-flush"
                  header-row-class-name="thead-light"
                  :data="revisiones"
                  @sort-change="sortChange"
                  v-loading="loadingTable"
                  element-loading-text="Cargando datos..."
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(255, 255, 255, 0.9)"
                  empty-text="No hay ningún elemento en esta tabla"
                >
                  <div slot="empty" v-if="loadingTable">
                    <img
                      src="/img/loading.gif"
                      style="height: 100px; width: 100px"
                    />
                  </div>

                  <!-- FECHA -->
                  <el-table-column
                    label="Fecha"
                    prop="fecha"
                    sortable="custom"
                    :min-width="60"
                  >
                    <template v-slot="{ row }">
                      <badge class="badge-dot mr-4" type="">
                        <span class="status small-text" v-if="row.createdAt">
                          {{ moment(row.createdAt).format("DD/MM/YYYY") }}
                          ({{ moment(row.createdAt).fromNow() }})
                        </span>
                        <span v-else class="small-text">Fecha no disponible</span>
                      </badge>
                    </template>
                  </el-table-column>

                  <!-- PRIORIDAD -->
                  <el-table-column
                    label="Prioridad"
                    prop="prioridad"
                    sortable="custom"
                    :min-width="40"
                  >
                    <template slot-scope="{ row }">
                      <span
                        class="badge badge-default badge-sm"
                        :style="getPrioridadStyle(row.prioridad)"
                      >
                        {{ row.prioridad || 'N/A' }}
                      </span>
                    </template>
                  </el-table-column>

                  <!-- ESTADO -->
                  <el-table-column
                    label="Estado"
                    prop="estado_incidencia"
                    sortable="custom"
                    :min-width="40"
                  >
                    <template slot-scope="{ row }">
                      <span
                        class="badge badge-default badge-sm"
                        :style="getEstadoStyle(row.estado_incidencia?.data?.attributes?.nombre)"
                      >
                        {{ row.estado_incidencia?.data?.attributes?.nombre || 'N/A' }}
                      </span>
                    </template>
                  </el-table-column>

                  <!-- USUARIO -->
                  <el-table-column
                    label="Creado por"
                    sortable="custom"
                    :min-width="80"
                  >
                    <template v-slot="{ row }">
                      <div class="d-flex align-items-center">
                        <img
                          v-if="row.usuario?.data?.attributes?.imagen_perfil?.data?.attributes?.url"
                          :src="row.usuario.data.attributes.imagen_perfil.data.attributes.url"
                          class="avatar rounded-circle mr-3"
                          alt="Perfil de usuario"
                        />
                        <img
                          v-else
                          src="/img/theme/user-default.png"
                          class="avatar rounded-circle mr-3"
                          alt="Usuario sin imagen"
                        />
                        <div>
                          <a
                            v-if="row.usuario?.data?.id"
                            :href="'/user-management/edit-user/' + row.usuario.data.id"
                            class="font-weight-bold"
                          >
                            {{
                              getUserFullName(row.usuario?.data?.attributes)
                            }}
                          </a>
                          <span v-else class="text-muted">
                            Usuario no disponible
                          </span>
                        </div>
                      </div>
                    </template>
                  </el-table-column>

                  <!-- EQUIPO -->
                  <el-table-column
                    label="Equipo"
                    sortable="custom"
                    min-width="100px"
                  >
                    <template v-slot="{ row }">
                      <div class="d-flex align-items-center">
                        <img
                          v-if="row.activo?.data?.attributes?.modelo?.data?.attributes?.imagen?.data?.attributes?.url"
                          :src="row.activo.data.attributes.modelo.data.attributes.imagen.data.attributes.url"
                          class="avatar rounded-circle mr-3"
                          alt="Imagen del equipo"
                        />
                        <img
                          v-else
                          src="/img/theme/device-default.png"
                          class="avatar rounded-circle mr-3"
                          alt="Equipo sin imagen"
                        />
                        <div>
                          <a
                            v-if="row.activo?.data?.id"
                            :href="'/activo-management/view-activo/' + row.activo.data.id"
                            class="font-weight-bold"
                          >
                            {{
                              getEquipoInfo(row.activo?.data?.attributes)
                            }}
                          </a>
                          <span v-else class="text-muted">
                            Equipo no disponible
                          </span>
                        </div>
                      </div>
                    </template>
                  </el-table-column>

                  <!-- ACCIONES -->
                  <el-table-column label="Acciones" align="left" :min-width="40">
                    <div slot-scope="{ row }" class="table-actions">
                      <base-button
                        outline
                        size="sm"
                        type="primary"
                        @click="viewTipo(row)"
                        style="padding-left: 10px; padding-right: 10px"
                        >Ver</base-button
                      >
                      <el-tooltip 
                        content="Descargar" 
                        placement="top"
                        v-if="row.pdf"
                      >
                        <a
                          type="text"
                          @click="downloadTipo(row)"
                          class="table-action"
                          data-toggle="tooltip"
                          style="cursor: pointer"
                        >
                          <i class="fas fa-download fa-lg"></i>
                        </a>
                      </el-tooltip>
                    </div>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="row">
                <div class="col-xl-4">
                  <el-select
                    class="select-primary pagination-select"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="col-xl-8">
                  <p class="card-category" style="margin-top: 0.5rem">
                    Mostrando {{ total ? from + 1 : 0 }} - {{ to }} de
                    {{ total }} registros

                    <span v-if="selectedRows.length">
                      &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                    </span>
                  </p>
                </div>
              </div>

              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              />
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BasePagination } from "@/components/";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  RadioButton,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import VueJsonToCsv from "vue-json-to-csv";
import axios from "axios";

export default {
  layout: "DashboardLayout",

  components: {
    BasePagination,
    flatPicker,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      query: null,
      revisiones: [],
      selectedRows: [],
      sort: "createdAt:desc",
      loadingTable: true,
      loadingColor: "#7f1058",
      loadingBgColor: "rgba(255, 255, 255, 0.9)",
      loadingHeight: 128,
      loadingWidth: 128,

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [25, 50, 100],
      },

      total: 0,
      loading: false,
      fdesde: null,
      fhasta: null,
      prioridad: null,
      prioridades: ["", "Alta", "Media", "Baja"],

      configInput: {
        allowInput: true,
        dateFormat: "d-m-Y",
        locale: Spanish,
      },

      totalAlta: 0,
      totalMedia: 0,
      totalBaja: 0,
      totalIncidencias: 0,

      itemsToExport: [],

      labels: {
        createdAt: { title: "Fecha" },
        prioridad: { title: "Prioridad" },
        "estado_incidencia.data.attributes.nombre": { title: "Estado" },
        "usuario.data.attributes.username": { title: "Creado por" },
        "activo.data.attributes.modelo.data.attributes.nombre": {
          title: "Equipo Modelo",
        },
        "activo.data.attributes.numero_serie": { title: "Equipo Nº serie" },
      },
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: false
    },
    fdesde: {
      handler: "getListDebounced",
      immediate: false
    },
    fhasta: {
      handler: "getListDebounced",
      immediate: false
    },
    prioridad: {
      handler: "getListDebounced",
      immediate: false
    },
    pagination: {
      handler: "getList",
      deep: true,
      immediate: false
    }
  },

  async created() {
    try {
      await this.getList();
    } catch (error) {
      console.error("Error initial load:", error);
    }
  },

  methods: {
    async getList() {
      this.loadingTable = true;

      try {
        const planta = localStorage.getItem("plantaSelected");
        
        const params = {
          idEmpresa: planta,
          search: this.query || "",
          sortOrder: this.sort.includes(":desc") ? "desc" : "asc"
        };

        if (this.fdesde) {
          params.fechaDesde = this.fdesde.split("-").reverse().join("-");
        }
        if (this.fhasta) {
          params.fechaHasta = this.fhasta.split("-").reverse().join("-");
        }
        if (this.prioridad) {
          params.prioridad = this.prioridad;
        }

        const response = await axios.get(
          "https://misepis-api.delfromsoftware.com/api/incidencias-list",
          { params }
        );

        const { incidencias, stats } = response.data;

        this.revisiones = incidencias;
        this.total = stats.total;
        this.totalIncidencias = stats.total;
        
        this.totalAlta = stats.porPrioridad.alta || 0;
        this.totalMedia = stats.porPrioridad.media || 0;
        this.totalBaja = stats.porPrioridad.baja || 0;

      } catch (error) {
        console.error("Error loading incidencias:", error);
        this.$notify({
          type: "danger",
          message: "Error al cargar las incidencias"
        });
      } finally {
        this.loadingTable = false;
      }
    },

    getListDebounced: _.debounce(function() {
      this.getList();
    }, 300), // Reduced debounce time for better responsiveness

    async exportData() {
      this.loading = true;
      var planta = localStorage.getItem("plantaSelected");

      await this.$store.dispatch("profile/me");
      let profile = await this.$store.getters["profile/me"];
      console.log(profile);
      var empresas = [];
      profile.empresas.forEach((element) => {
        empresas.push(element.id);
      });

      if (planta != 0) {
        empresas = [planta];
      }

      var filters = {
        $and: [
          {
            activo: {
              empresa: {
                id: { $in: empresas },
              },
            },
          },
          { $or: [] },
        ],
      };

      if (this.query) {
        console.log(filters["$and"][1]["$or"]);

        filters["$and"][1]["$or"].push(
          {
            activo: {
              modelo: {
                nombre: { $containsi: this.query },
              },
            },
          },
          {
            activo: {
              numero_serie: { $containsi: this.query },
            },
          },
          {
            usuario: {
              username: { $containsi: this.query },
            },
          }
        );
      }

      if (this.fdesde) {
        var newdate = this.fdesde.split("-").reverse().join("-");
        filters["$and"].push({
          createdAt: { $gt: newdate },
        });
      }

      if (this.fhasta) {
        var newdate = this.fhasta.split("-").reverse().join("-");
        filters["$and"].push({
          createdAt: { $lt: newdate },
        });
      }

      if (this.prioridad) {
        filters["$and"].push({
          prioridad: { $containsi: this.prioridad },
        });
      }

      let params = {
        ...(this.sort ? { sort: this.sort } : {}),

        filters: filters,
        pagination: {
          page: this.pagination.currentPage,
          pageSize: this.pagination.perPage,
        },
      };
      await this.$store.dispatch("incidencias/list", params).then(async () => {
        let paramsExport = {
          ...(this.sort ? { sort: this.sort } : {}),

          filters: filters,
          pagination: {
            page: 1,
            pageSize: this.$store.getters["incidencias/listTotal"],
          },
        };

        await this.$store
          .dispatch("incidencias/list", paramsExport)
          .then(() => {
            var items = this.$store.getters["incidencias/list"];

            console.log(items.length);

            var itemsFlatten = [];
            items.forEach((item) => {
              itemsFlatten.push(this.flattenObject(item));
            });

            console.log(itemsFlatten);

            this.itemsToExport = itemsFlatten;

            /* const elem = this.$refs.myBtn;
          elem.click(); */
            setTimeout(() => {
              this.$refs.myBtn.$el.click();
              this.loading = false;
            }, 500);
          });
      });
    },
    flattenObject(obj) {
      let flattenKeys = {};
      for (let i in obj) {
        if (!obj.hasOwnProperty(i)) continue;
        if (typeof obj[i] == "object") {
          // flattenKeys[i] = obj[i];
          let flatObject = this.flattenObject(obj[i]);
          for (let j in flatObject) {
            if (!flatObject.hasOwnProperty(j)) continue;
            flattenKeys[i + "." + j] = flatObject[j];
          }
        } else {
          flattenKeys[i] = obj[i];
        }
      }
      return flattenKeys;
    },

    viewTipo(row) {
      console.log(row);
      this.$router.push({
        name: "View incidencia",
        params: { id: row.id },
      });
    },

    downloadTipo(row) {
      console.log(row);

      const url_adicional = row.pdf;

      console.log(url_adicional);

      if (url_adicional) {
        window.open(url_adicional, "_blank");
      } else {
        this.$notify({
          type: "danger",
          message: `No se puede abrir el documento`,
        });
      }
    },

    async deleteTipo(id) {
      if (this.$isDemo == 1 && ["1", "2"].includes(id)) {
        this.$notify({
          type: "danger",
          message: "You are not allowed not change data of default empresa.",
        });
        return;
      }
      try {
        const confirmation = await swal.fire({
          title: `Eliminar esta incidencia?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "No, mantenerla",
          confirmButtonClass: "btn btn-primary",
          cancelButtonClass: "btn btn-warning",
        });

        if (confirmation.value === true) {
          await this.$store.dispatch("incidencias/destroy", id);
          await this.getList();
          this.$notify({
            type: "success",
            message: "Incidencias eliminada correctamente.",
          });
        }
      } catch (error) {
        if (error.response.data.errors[0]) {
          this.$notify({
            type: "danger",
            message: "This Empresa still has associated Items.",
          });
        } else {
          this.$notify({
            type: "danger",
            message: "Oops, something went wrong!",
          });
        }
      }
    },
    addTipo() {
      this.$router.push({ name: "Add incidencia" });
    },
    editTipo(row) {
      console.log(row);
      this.$router.push({
        name: "Edit incidencia",
        params: { id: row.id },
      });
    },
    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `${prop}:desc`;
      } else {
        this.sort = `${prop}:asc`;
      }
      this.getList();
    },
    getPrioridadStyle(prioridad) {
      const styles = {
        Alta: { backgroundColor: 'red' },
        Media: { backgroundColor: 'orange' },
        Baja: { backgroundColor: 'green' },
        default: { backgroundColor: 'gray' }
      };
      return styles[prioridad] || styles.default;
    },

    getEstadoStyle(estado) {
      return {
        backgroundColor: estado === 'Abierta' ? 'info' : 'green'
      };
    },

    getUserFullName(attributes) {
      if (!attributes) return 'Usuario no disponible';
      const nombre = attributes.nombre || '';
      const apellidos = attributes.apellidos || '';
      return nombre || apellidos ? `${nombre} ${apellidos}`.trim() : 'Usuario sin nombre';
    },

    getEquipoInfo(attributes) {
      if (!attributes?.modelo?.data?.attributes) return 'Equipo no disponible';
      const modeloNombre = attributes.modelo.data.attributes.nombre || 'Sin modelo';
      const numeroSerie = attributes.numero_serie || 'Sin número de serie';
      return `${modeloNombre} - ${numeroSerie}`;
    },
  },
};
</script>

<style scoped>
/* Estilos para el loading de la tabla */
/deep/ .el-table {
  position: relative;
  
  .el-loading-mask {
    background-color: rgba(255, 255, 255, 0.9);
  }

  .el-loading-spinner {
    .el-icon-loading {
      color: #7f1058;
      font-size: 2rem;
    }
    
    .el-loading-text {
      color: #7f1058;
      font-weight: 600;
      margin-top: 10px;
    }
  }
}

.table-responsive {
  min-height: 200px;
}

.avatar {
  width: 36px;
  height: 36px;
  object-fit: cover;
}

.table-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.badge {
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: capitalize;
}

.badge-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.small-text {
  font-size: 0.7rem;
  color: #525f7f;
  font-weight: 400;
}
</style>
